var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstanceNotificationType } from "../RequestAxios/RequestAxiosNotificationType";
var notificationTypeUrl = function () { return "/notification_types/list_for_user"; };
var userConfigurationUrl = function () { return "/config"; };
var subscribeUrl = function () { return "/subscribe"; };
var unsubscribeUrl = function () { return "/unsubscribe"; };
export var getNotificationTypes = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceNotificationType.buffedInstances.get(notificationTypeUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getUserConfiguration = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceNotificationType.buffedInstances.get(userConfigurationUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var createOrUpdateUserConfiguration = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceNotificationType.buffedInstances.post(userConfigurationUrl(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var subscribeToEntity = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceNotificationType.buffedInstances.post(subscribeUrl(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var unsubscribeFromEntity = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceNotificationType.buffedInstances.post(unsubscribeUrl(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90aWZpY2F0aW9uVHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5vdGlmaWNhdGlvblR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0EsT0FBTyxFQUFFLDBCQUEwQixFQUFFLE1BQU0sOENBQThDLENBQUM7QUFFMUYsSUFBTSxtQkFBbUIsR0FBRyxjQUFNLE9BQUEsbUNBQW1DLEVBQW5DLENBQW1DLENBQUM7QUFDdEUsSUFBTSxvQkFBb0IsR0FBRyxjQUFNLE9BQUEsU0FBUyxFQUFULENBQVMsQ0FBQztBQUM3QyxJQUFNLFlBQVksR0FBRyxjQUFNLE9BQUEsWUFBWSxFQUFaLENBQVksQ0FBQztBQUN4QyxJQUFNLGNBQWMsR0FBRyxjQUFNLE9BQUEsY0FBYyxFQUFkLENBQWMsQ0FBQztBQUU1QyxNQUFNLENBQUMsSUFBTSxvQkFBb0IsR0FBRywrQ0FBVSxPQUFPOzs7O29CQUdsQyxxQkFBTSwwQkFBMEIsQ0FBQyxlQUFlLENBQUMsR0FBRyxDQUVuRSxtQkFBbUIsRUFBRSxDQUFDLEVBQUE7O2dCQUZoQixJQUFJLEdBQUssQ0FBQSxTQUVPLENBQUEsS0FGWjtnQkFHWixzQkFBTyxJQUFJLEVBQUM7OztLQUNiLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxvQkFBb0IsR0FDL0IsK0NBQVUsT0FBTzs7OztvQkFFYixxQkFBTSwwQkFBMEIsQ0FBQyxlQUFlLENBQUMsR0FBRyxDQUNsRCxvQkFBb0IsRUFBRSxDQUN2QixFQUFBOztnQkFISyxJQUFJLEdBQ1YsQ0FBQSxTQUVDLENBQUEsS0FIUztnQkFJWixzQkFBTyxJQUFJLEVBQUM7OztLQUNiLENBQUM7QUFFSixNQUFNLENBQUMsSUFBTSwrQkFBK0IsR0FBRyxVQUM3QyxPQUF1QyxxQ0FDdEMsT0FBTzs7OztvQkFFTixxQkFBTSwwQkFBMEIsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUNuRCxvQkFBb0IsRUFBRSxFQUN0QixPQUFPLENBQ1IsRUFBQTs7Z0JBSkssSUFBSSxHQUNWLENBQUEsU0FHQyxDQUFBLEtBSlM7Z0JBS1osc0JBQU8sSUFBSSxFQUFDOzs7S0FDYixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQUcsVUFDL0IsT0FBNEMscUNBQzNDLE9BQU87Ozs7b0JBRU4scUJBQU0sMEJBQTBCLENBQUMsZUFBZSxDQUFDLElBQUksQ0FDbkQsWUFBWSxFQUFFLEVBQ2QsT0FBTyxDQUNSLEVBQUE7O2dCQUpLLElBQUksR0FDVixDQUFBLFNBR0MsQ0FBQSxLQUpTO2dCQUtaLHNCQUFPLElBQUksRUFBQzs7O0tBQ2IsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLHFCQUFxQixHQUFHLFVBQ25DLE9BQTRDLHFDQUMzQyxPQUFPOzs7O29CQUVOLHFCQUFNLDBCQUEwQixDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQ25ELGNBQWMsRUFBRSxFQUNoQixPQUFPLENBQ1IsRUFBQTs7Z0JBSkssSUFBSSxHQUNWLENBQUEsU0FHQyxDQUFBLEtBSlM7Z0JBS1osc0JBQU8sSUFBSSxFQUFDOzs7S0FDYixDQUFDIn0=